var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{staticClass:"toggle",attrs:{"type":"checkbox","id":"toggle"}}),_c('label',{attrs:{"for":"toggle"}},[_c('span',{staticClass:"on"},[_vm._v(_vm._s(_vm.$t('enable')))]),_c('span',{staticClass:"off"},[_vm._v(_vm._s(_vm.$t('disable')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }